import { EVENTO_LISTAGEM_FILTRADA, buscarTotalDoRodape } from './service/total_do_rodape';

function dispararBuscaDoTotal(evento) {
  const detalhe = evento && evento.detail;
  buscarTotalDoRodape({ parametros: detalhe ? detalhe.params : undefined });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dispararBuscaDoTotal);
} else {
  dispararBuscaDoTotal();
}

document.addEventListener(EVENTO_LISTAGEM_FILTRADA, dispararBuscaDoTotal);
